import { useState } from 'react';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { uploadFile, type UploadedFile } from '../../lib/upload';

interface ChildDropzoneProps {
  kind: 'image' | 'file';
  onUploaded: (files: UploadedFile[]) => Promise<void>;
}

export default function ChildDropzone({ kind, onUploaded }: ChildDropzoneProps) {
  const [uploading, setUploading] = useState(false);

  async function handleDrop(files: File[]) {
    setUploading(true);
    try {
      const uploaded = await Promise.all(files.map(uploadFile));
      await onUploaded(uploaded.filter((file): file is UploadedFile => file !== null));
    } finally {
      setUploading(false);
    }
  }

  return (
    <Dropzone
      onDrop={handleDrop}
      onReject={() => notifications.show({ color: 'red', message: 'Some files were not accepted here' })}
      accept={kind === 'image' ? IMAGE_MIME_TYPE : undefined}
      loading={uploading}
    >
      <Text ta="center" size="sm" p="sm">
        Drag {kind === 'image' ? 'images' : 'files'} here, or click to select (multiple allowed)
      </Text>
    </Dropzone>
  );
}
